import { Map } from 'lucide-react';

export const WorldMapCard = ({ playersOnline, pingMs }) => (
  <div className="card border border-white/10 bg-base-200/20">
    <div className="card-body gap-4">
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="flex items-center gap-2 text-sm font-semibold">
            <Map className="h-4 w-4 text-primary" />
            World map
          </div>
          <div className="mt-1 text-xs text-base-content/65">Live map embed.</div>
        </div>
        <div className="badge badge-outline border-white/10 text-xs">Live</div>
      </div>

      <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-base-100">
        <iframe
          title="Kweebec World Map"
          src="https://icy-silence-a2e7.1337sunway.workers.dev/"
          className="block h-72 w-full"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
          style={{ border: 0 }}
        />

        <div className="grid gap-3 border-t border-white/10 bg-base-100/80 p-4 sm:grid-cols-3">
          <div className="grid gap-1">
            <div className="text-xs uppercase tracking-wide text-base-content/60">Claim system</div>
            <div className="text-sm font-semibold">Bed claims chunk</div>
          </div>
          <div className="grid gap-1">
            <div className="text-xs uppercase tracking-wide text-base-content/60">Raiding</div>
            <div className="text-sm font-semibold">Explosives break bed</div>
          </div>
          <div className="grid gap-1">
            <div className="text-xs uppercase tracking-wide text-base-content/60">Online / ping</div>
            <div className="text-sm font-semibold">{typeof playersOnline === 'number' ? playersOnline : '—'} / {typeof pingMs === 'number' ? `${pingMs}ms` : '—'}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
